/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import { translate, prettyTracker, imagePrettyUrl } from 'gatsby-core-theme/src/helpers/getters';
import Modal from 'gatsby-core-theme/src/hooks/modal';
import Rating from 'gatsby-core-theme/src/components/molecules/star-rating';
import { Context } from '~context/MainProvider';
import RegistrationSteps from 'gatsby-rage-seo-theme/src/components/molecules/registration-steps';
import styles from './provider-list.module.scss';

const DefImg = ({ isStorybook, alt = '' }) => (
  <img
    alt={alt}
    src={isStorybook ? './tv-logo.png' : '../../../../../images/tv-logo.png'}
    width={223}
    height={174}
  />
);

const ProviderList = ({ pageContext, isStorybook = false }) => {
  const page = pageContext?.page;
  const providers = pageContext?.page?.relation?.providers;
  const { translations } = useContext(Context) || {};

  return (
    <div className={styles.providerList}>
      {providers?.length &&
        providers
          .sort((a, b) => a.sort_order - b.sort_order)
          .map((provider, index) => (
            <div className={`${styles.providerItem}`} key={provider.id}>
              <div className={styles.tv}>
                <Button
                  to={prettyTracker(provider, 'main', true)}
                  isInternalLink={false}
                  targetBlank={false}
                  noStyle
                  gtmClass="provider-list-gtm btn-cta image-cta"
                  btnText={
                    <span className={styles.base}>
                      <div>
                        <LazyImage
                          src="../../../../../images/tv-logo.png"
                          alt={provider.name}
                          width={223}
                          height={145}
                          offset={1400}
                          defaultImg={<DefImg alt={provider.name} isStorybook={isStorybook} />}
                        />
                        Annonce
                      </div>
                      <div className={styles.tvLogo}>
                        {provider?.laptop_logo ? (
                          <div className={styles.imgContainer}>
                            <LazyImage
                              src={imagePrettyUrl(provider.laptop_logo)}
                              alt={provider.name}
                              offset={1400}
                            />
                          </div>
                        ) : (
                          <span className={styles.providerName}>{provider?.name}</span>
                        )}
                      </div>
                    </span>
                  }
                />
              </div>
              <div className={styles.content}>
                <div className={styles.header}>
                  <h2>
                    {provider?.name}
                    {` ${translate(translations, 'live_streaming', 'Live Streaming')}`}
                  </h2>
                  <Rating
                    numOfStars={5}
                    rating={provider.rating}
                    path={page.path}
                    halfStars={false}
                    iconFull={
                      <LazyImage
                        src={isStorybook ? './ratting.png' : '../../../../images/ratting.png'}
                        width={22}
                        height={22}
                        offset={1400}
                      />
                    }
                    iconEmpty={
                      <LazyImage
                        src={
                          isStorybook ? './ratting-fade.png' : '../../../../images/ratting-fade.png'
                        }
                        width={22}
                        height={22}
                        offset={1400}
                      />
                    }
                  />
                </div>
                <p className={styles.providerDescriptions}>
                  <span>{`${translate(translations, 'selection', 'Selection')}: `}</span>
                  {provider?.sports_data.soccer?.selection_content}
                </p>
                <p className={styles.providerDescriptions}>
                  <span>{`${translate(translations, 'quality', 'Quality')}: `}</span>
                  {provider?.sports_data.soccer?.quality_content}
                </p>
                <p className={styles.providerDescriptions}>
                  <span>{`${translate(translations, 'price', 'Price')}: `}</span>
                  {provider?.sports_data.soccer?.price_content}
                </p>
                <div className={styles.steps}>
                  <strong>
                    {translate(
                      translations,
                      'how_to_watch_live_stream',
                      'How to watch live stream'
                    )}
                    :
                  </strong>
                  <RegistrationSteps provider={provider} isStorybook={isStorybook} />
                </div>
              </div>
              <div className={styles.cta}>
                <Button
                  to={prettyTracker(provider, 'main', true)}
                  isInternalLink={false}
                  targetBlank={false}
                  className="circle"
                  primaryColor
                  gtmClass="provider-list-gtm"
                  btnText={
                    <>
                      <span>{` ${translate(
                        translations,
                        'watch_footbal_live',
                        'Watch footbal live'
                      )}`}</span>
                      <span>{provider.name}</span>
                    </>
                  }
                />
                <div className={styles.terms}>
                  {provider?.sports_data.soccer?.disclaimer && (
                    <Modal content={provider?.sports_data.soccer?.disclaimer}>
                      <span className={styles.modalTrigger}>
                        {translate(translations, 'terms_and_conditions', 'Terms & conditions')}
                      </span>
                    </Modal>
                  )}
                </div>
                {index === 0 && (
                  <p className={styles.qualifyText}>
                    {translate(
                      translations,
                      'qualify_for_bet',
                      'To qualify, you simply need to have a funded account or have placed a bet within the last 24 hours.'
                    )}
                  </p>
                )}
              </div>
            </div>
          ))}
    </div>
  );
};

ProviderList.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      path: PropTypes.string,
      relation: PropTypes.shape({}),
    }),
  }).isRequired,
  isStorybook: PropTypes.bool,
};

export default ProviderList;
